import { FieldType, IFormFieldInfo } from "@lib";
import { FormFieldControl, FormFieldControlContext } from "./form-field-control";
import { TextBoxFormFieldControl } from "./standart/text-box.form-field-control";
// import { PhoneBoxFormFieldControl } from "./standart/phone-box.form-field-control";
import { PasswordBoxFormFieldControl } from "./standart/password-box.form-field-control";
import { TextAreaFormFieldControl } from "./standart/text-area.form-field-control";
// import { CheckBoxFormFieldControl } from "./standart/check-box.form-field-control";
// import { DateTimeFormFieldControl } from "./standart/date-time.form-field-control";
// import { SelectFormFieldControl } from "./standart/select.form-field-control";
// import { CompositeFormFieldControl } from "./standart/composite.form-field-control";
// import { TagsFormFieldControl } from "./standart/tags.form-field-control";
import { AppException } from "@/core/exceptions";

export abstract class FormFieldControlFactory {
    public static fromField(field: IFormFieldInfo, context?: FormFieldControlContext): FormFieldControl {
        switch (field.type) {
            case FieldType.String:
                return new TextBoxFormFieldControl(field, context);
            // case FieldType.Phone:
            //     return new PhoneBoxFormFieldControl(field, context);
            case FieldType.Password:
                return new PasswordBoxFormFieldControl(field, context);
            case FieldType.Text:
                return new TextAreaFormFieldControl(field, context);
            // case FieldType.Checkbox:
            //     return new CheckBoxFormFieldControl(field, context);
            // case FieldType.DateTime:
            // case FieldType.Date:
            // case FieldType.Time:
            //     return new DateTimeFormFieldControl(field, context);
            // case FieldType.Select:
            //     return new SelectFormFieldControl(field, context);
            // case FieldType.Composite:
            //     return new CompositeFormFieldControl(field, context);
            // case FieldType.Tags:
            //     return new TagsFormFieldControl(field, context);
        }

        throw new AppException(`Field type ${field.type} cannot be converted.`);
    }

    public static formatValue(value: any, field: IFormFieldInfo, context?: FormFieldControlContext): string {
        const fieldControl = FormFieldControlFactory.fromField(field, context);
        fieldControl.value = value;
        return fieldControl.getValueFormatted();
    }
}
